export const weatherConfig = {
    CURRENT_LOCATION_TEMP: "King's Park",
    CURRENT_LOCATION_RAIN: "Central & Western District"
}